export default __webpack_public_path__ + "static/media/backbone.1ffc4a62.svg";